import Vue from 'vue'
import api from '@/api/index'
import store from '@/store'
import {
  getStore,
  setStore,
  removeStore
} from '@/utils/store'
export const USER_SIGNIN = 'USER_SIGNIN' // 登录
export const UPDATE_TOKEN = 'UPDATE_TOKEN' // 置换token
export const USER_SIGNOUT = 'USER_SIGNOUT' // 登出
export const WRITE_USER_INFO = 'WRITE_USER_INFO' // 写入用户信息
const user = {
  state: getStore({
    name: 'userInfo',
    accountStatus: 1
  }) || {},

  mutations: {
    [USER_SIGNIN] (state, userInfo) {
      setStore({
        name: 'userInfo',
        content: Object.assign(state, userInfo),
        type: false
      })
      Object.assign(state, userInfo)
    },
    [USER_SIGNOUT] (state) {
      removeStore({
        name: 'userInfo'
      })
      Object.keys(state).forEach(k => Vue.delete(state, k))
    }
  },

  actions: {
    // 登录
    [USER_SIGNIN] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.login(user).then((res) => {
          const {
            data
          } = res
          commit(USER_SIGNIN, data)
          resolve()
        }, (data) => {
          commit(USER_SIGNOUT)
        })
      })
    },
    // 置换accessToken
    [UPDATE_TOKEN] ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        const data = {
          refreshToken: store.user.refreshToken
        }
        api.refreshToken(data).then((res) => {
          commit(USER_SIGNIN, res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出登录
    [USER_SIGNOUT] ({
      commit
    }) {
      commit(USER_SIGNOUT)
    },
    [WRITE_USER_INFO] ({
      commit
    }, userInfo) {
      commit(USER_SIGNIN, userInfo)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js